const { SwitchClient, KubeClient, EchoClient } = require('./AxiosClient');

/**
 * Class intended to provide axios client, respecting singleton pattern.
 */
class AxiosFactory {
    constructor() {
        this.kubeInstance = undefined;
        this.echoInstance = undefined;
        this.switchInstance = null;
    }

    static createSwitchInstance() {
        if (!this.switchInstance) {
            this.switchInstance = new SwitchClient();
        }

        return this.switchInstance;
    }

    static createKubeInstance() {
        if (!this.kubeInstance) {
            this.kubeInstance = new KubeClient();
        }

        return this.kubeInstance;
    }

    static createEchoInstance() {
        if (!this.echoInstance) {
            this.echoInstance = new EchoClient();
        }

        return this.echoInstance;
    }
}

module.exports = AxiosFactory;
